module.exports = __webpack_public_path__ + "static/media/stars_mob.bd12fb8b.svg";